module.exports = __webpack_public_path__ + "static/media/pesopluma-07-17-320x320-119fd10c44-320x320.492c238c.jpg";